import PageIndex from 'components/UI/PageIndex';
import { getAlertIdentifier } from 'features/Weather/features/WeatherAlerts/utils/alertData.utils';
import { useDispatch, useSelector } from 'react-redux';
import FemaDetails from '../FemaAlertList/components/FemaDetails';
import FemaOptions from '../FemaAlertList/components/FemaOptions';
import AlertListHeader from './components/AlertListHeader/AlertListHeader';
import AlertCard from './features/AlertCard/index.web';
import {
  selectFilteredAlertList,
  selectPageIndex,
  selectSortedPagedAlertList,
} from './state/selectors/alertListSelectors';
import { setPageIndex } from './state/slices/alertListSlice';

const alertLimit = 100;

const AlertList = ({ title, perms, canDeleteAlerts }) => {
  const dispatch = useDispatch();
  const sortedPagedAlertList = useSelector(selectSortedPagedAlertList);
  const filteredAlertList = useSelector(selectFilteredAlertList);
  const pageIndex = useSelector(selectPageIndex);

  return (
    <div className="d-flex flex-column h-100">
      <AlertListHeader title={title} perms={perms} />
      <div className={`overflow-auto ${!sortedPagedAlertList?.length ? 'overflow-hidden' : ''}`}>
        {sortedPagedAlertList?.length ? (
          sortedPagedAlertList?.map((alert, index) => {
            const alertId = getAlertIdentifier(alert, index);
            // Legacy FEMA rows (isLegacyFemaAlert) get the badge on the card, but keep the default
            // details and actions: they carry no stored IPAWS message to update or cancel.
            const isFemaAlert = alert.alertSource === 'fema';
            // canCloseAlert: true if alert has workplaceId or globalActionId

            const canCloseAlert =
              alert?.alertSource !== 'fema' &&
              !!(alert && (alert.workplaceId || alert.globalActionId));
            return (
              <AlertCard
                key={alertId}
                index={index}
                alert={alert}
                canCloseAlert={canCloseAlert}
                canDeleteAlerts={canDeleteAlerts}
                renderDetails={isFemaAlert ? <FemaDetails alert={alert} /> : undefined}
                renderActions={isFemaAlert ? <FemaOptions alert={alert} /> : undefined}
              />
            );
          })
        ) : (
          <p className="w-100 py-3 text-center">No Results Found...</p>
        )}
      </div>
      <PageIndex
        pageIndex={pageIndex}
        setPageIndex={(value) => dispatch(setPageIndex(value))}
        maxPages={filteredAlertList?.length / alertLimit}
      />
    </div>
  );
};

export default AlertList;
